import { Transition } from "history";
import { ReportSummaryItemApi } from "../api/Reports";
import { isNavigatingWithinReportScope } from "./reportNavigationUnlock";
import { ReportDetailTypes } from "./utils";

interface ReportLocationState {
  stepDone: boolean;
}

const ReportUnlockHook = (
  tx: Transition,
  isReadOnly: boolean,
  report: ReportSummaryItemApi | undefined,
  id: string | undefined,
  getCurrentType: () => ReportDetailTypes,
  performUnlock: (
    workflowRunUUID: string,
    title: string,
    message: string,
    afterSuccess: () => void,
    positiveAction?: boolean,
    forceUnlock?: boolean,
    bypassUnlockPermission?: boolean
  ) => void,
  isError: boolean,
  workflowRunUuidOverride?: string | null
) => {
  // Unlock guard executed when trying to navigate from this screen.
  if (!report || isError || isReadOnly || report.is_locked) {
    tx.retry();
    return;
  }
  if (isNavigatingWithinReportScope(tx.location.pathname, id)) {
    tx.retry();
    return;
  }
  const currentType = getCurrentType();
  if (currentType === ReportDetailTypes.SUMMARY) {
    tx.retry();
    return;
  }
  const workflowRunUuid =
    workflowRunUuidOverride === undefined
      ? report.workflow_run_uuid
      : workflowRunUuidOverride;
  if (!workflowRunUuid) {
    tx.retry();
    return;
  }

  // Adding a DirectState with stepDone true indicates the navigation the step is done
  const redirectState = (tx.location.state as ReportLocationState) ?? null;
  if (redirectState && redirectState.stepDone) {
    performUnlock(
      workflowRunUuid,
      "",
      "",
      () => {
        tx.retry();
      },
      true,
      true,
      true
    );
  }

  let typeMessage = "";
  switch (currentType) {
    case ReportDetailTypes.PROFILE_CONFIRM:
      typeMessage = "Profile Confirm";
      break;
    case ReportDetailTypes.MANUAL_RATE:
      typeMessage = "Manual rate";
      break;
    case ReportDetailTypes.SYSTEM:
      typeMessage = "System Rate";
      break;
  }
  const title = `Exit ${typeMessage}?`;
  const message = `By doing this you will Exit ${typeMessage} and return to Reports.`;

  performUnlock(
    workflowRunUuid,
    title,
    message,
    () => {
      tx.retry();
    },
    false,
    false,
    true
  );
};

export default ReportUnlockHook;
